import { mostSearchedRegions } from '@sly/core/constants/agents';
import Link from 'next/link';
import MostSearchedRegionsContent from 'sly/agentsPage/components/AgentsContent/MostSearchedRegions/MostSearchedRegionsContent';
import Heading from 'sly/system/Heading';

export default function MostSearchedRegions() {
  return (
    <>
      <div data-tp-id='gen-div-2f4df10a-4b7c-4ecb-9e8f-5b2fb61545d2'>
        <Heading
          as='h2'
          className='mb-12 text-center'
          data-tp-id='gen-Heading-3df8ab1a-446a-48bf-ab88-601fc7142dd8'
        >
          Search senior living agents by region
        </Heading>
      </div>
      <div
        className='mb-16 grid grid-cols-[auto] gap-4 md:grid-cols-2 md:gap-6 lg:grid-cols-[var(--col4)_var(--col4)_var(--col4)]'
        data-tp-id='gen-div-5195d73d-e4bf-46d7-b3fd-d057a5eb063b'
      >
        {mostSearchedRegions.map((region) => (
          <Link
            legacyBehavior
            href={region.to}
            key={region.title}
            data-tp-id='gen-Link-354d70f1-0331-4a15-b76b-d470feee8a54'
          >
            <a className='block'>
              <MostSearchedRegionsContent
                image={region.image}
                alt={region.title}
                title={region.title}
                states={region.states}
              />
            </a>
          </Link>
        ))}
      </div>
    </>
  );
}
